import { defineFcm } from '../shared/factory';

export const FCM_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS = defineFcm('corgi_use_assets_domain_for_scripts')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Corgi server',
		description:
			'Enable to use the assets domain (e.g. https://assets.change.org) for corgi JS scripts instead of the default domain (e.g. https://www.change.org)',
		import: false,
	});
